import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Ticket } from '@types'

import { FlexCol, FlexRow } from '../StyledComponents'

const handleDate = (date?: string) => {
  if (date) {
    const dateValue = new Date(date)
    const hour = dateValue.getHours().toString().padStart(2, '0')
    const minutes = dateValue.getMinutes().toString().padStart(2, '0')
    return `${hour}:${minutes}`
  }
  return ''
}

interface DriverBarlightProps {
  ticket: Ticket
}

const DriverBarlight: FC<DriverBarlightProps> = ({
  ticket: { driver, tripStartDate, tripEndDate },
}) => {
  const { t } = useTranslation()

  const barlightColor =
    !tripStartDate && !tripEndDate
      ? 'red'
      : tripStartDate && !tripEndDate
      ? 'yellow'
      : tripStartDate && tripEndDate
      ? 'green'
      : 'red'

  const getTooltipContent = (color: string) => {
    const loadingText = `${t('driver_bar_light.loading')}: ${
      color === 'red' ? t('driver_bar_light.pending') : handleDate(tripStartDate)
    }`
    const unloadingText = `${t('driver_bar_light.unloading')}: ${
      color === 'red' ? t('driver_bar_light.pending') : handleDate(tripEndDate)
    }`

    return `${loadingText}<br />${unloadingText}`
  }

  return (
    <FlexRow>
      <FlexCol className={`barlight ${barlightColor}`} />
      <FlexCol
        style={{
          padding: '0.75rem',
          flex: 1,
          gap: '0.25rem',
          justifyContent: 'flex-start',
          textAlign: 'left',
        }}
      >
        <span
          style={{
            fontWeight: 'bold',
            fontSize: '12px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          title={driver ? `${driver.firstName} ${driver.lastName}` : undefined}
        >
          {driver
            ? `${driver.firstName} ${driver.lastName?.charAt(0)}`
            : t('tpl_dashboard_batches.without_driver')}
        </span>
        <span dangerouslySetInnerHTML={{ __html: getTooltipContent(barlightColor) }} />
      </FlexCol>
    </FlexRow>
  )
}

export default DriverBarlight
